import React from 'react';
import { RouteComponentProps } from 'react-router';

import { PopupError } from 'src/app/components/Popup/PopupError';
import { POPUPERROR_TYPE } from 'src/app/constants/popup';
import { withRouter } from 'src/app/helpers/router';

type MyInjectedProps = RouteComponentProps;

type MyProps = MyInjectedProps;

@withRouter()
class MyClassPopupErrorInternet extends React.Component<MyProps> {
  constructor(props: MyProps) {
    super(props);

    this.reload = this.reload.bind(this);
  }

  render(): JSX.Element {
    return (
      <PopupError
        error={POPUPERROR_TYPE.INTERNET}
        close={this.reload}
      />
    );
  }

  private reload(): void {
    this.props.history.go(0);
  }
}

export const PopupErrorInternet = MyClassPopupErrorInternet as React.ComponentClass<{}>;
